<template>
  <div v-if="results && lastUpdated">
    <b-row>
      <b-col>
        <p class="mb-1">Người dùng</p>
        <b v-if="results.totalUsers">{{ results.totalUsers }}</b>
      </b-col>
      <b-col>
        <p class="mb-1">Số phiên tương tác</p>
        <b v-if="results.sessions">{{ results.sessions }}</b>
      </b-col>
      <b-col>
        <p class="mb-1">Thời gian phiên hoạt động trung bình</p>
        <b v-if="results.averageSessionDuration">{{ results.averageSessionDuration }}</b>
      </b-col>
      <b-col>
        <p class="mb-1">Số lượng sự kiện</p>
        <b v-if="results.eventCount">{{ results.eventCount }}</b>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <p class="mb-1">Số người dùng mới</p>
        <b v-if="results.newUsers">{{ results.newUsers }}</b>
      </b-col>
      <b-col>
        <p class="mb-1">Tỷ lệ tương tác</p>
        <b v-if="results.engagementRate">{{ results.engagementRate|formatPercent }} %</b>
      </b-col>
      <b-col>
        <p class="mb-1">Thời gian tương tác trung bình</p>
        <b v-if="results.avgEngagementDuration">{{ results.avgEngagementDuration }}</b>
      </b-col>
      <b-col>
        <p class="mb-1">Tỷ lệ thoát</p>
        <b v-if="results.bounceRate">{{ results.bounceRate|formatPercent }} %</b>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col cols="2" class="pt-2">
        <b-form-group label="Chọn khoảng thời gian:">
          <b-form-select v-model="selectedTimeRange" :options="timeRanges" @change="getAnalytics"></b-form-select>
        </b-form-group>
        <div v-if="togglePicker">
          <date-range-picker
            v-model="dateRange"
            :date-format="dateFormat"

            :locale-data="localeData"
            :opens="opens"
            @update="pickerUpdate"
          ></date-range-picker>
        </div>
      </b-col>
    </b-row>
    <b-row align-h="between" class="mt-4">
      <b-col cols="6">
        <b>Nhóm kênh chính của phiên</b>
      </b-col>
      <b-col cols="6"></b-col>
    </b-row>
    <b-row align-h="between" v-if="results && results.channelGroup && lastUpdated">
      <b-col>
        <p>Direct:
          <b class="ml-1" v-if="results.channelGroup.Direct">{{ results.channelGroup.Direct }}</b>
        </p>
      </b-col>
      <b-col>
        <p>Referral:
          <b class="ml-1" v-if="results.channelGroup.Referral">{{ results.channelGroup.Referral }}</b>
        </p>
      </b-col>
      <b-col>
        <p>Organic Search:
          <b class="ml-1" v-if="results.channelGroup.OrganicSearch">{{ results.channelGroup.OrganicSearch }}</b>
        </p>
      </b-col>
      <b-col>
        <p>Organic Social:
          <b class="ml-1" v-if="results.channelGroup.OrganicSocial">{{ results.channelGroup.OrganicSocial }}</b>
        </p>
      </b-col>
      <b-col>
        <p>Unassigned:
          <b class="ml-1" v-if="results.channelGroup.Unassigned">{{ results.channelGroup.Unassigned }}</b>
        </p>
      </b-col>

    </b-row>
    <div>
      <i style="font-size: 11px" class="text-muted">Cập nhập lúc: {{ lastUpdated }}</i>
    </div>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  name: "AnalyticsData",
  components: {DateRangePicker},
  data() {
    let today = new Date()
    today.setHours(0, 0, 0, 0)
    return {
      selectedTimeRange: '7daysAgo',
      timeRanges: [
        {value: null, text: 'Chọn khoảng thời gian'},
        {value: 'customize', text: 'Tùy chỉnh'},
        {value: 'today', text: 'Hôm nay'},
        {value: 'yesterday', text: 'Hôm qua'},
        {value: '7daysAgo', text: '7 ngày trước'},
        {value: '14daysAgo', text: '14 ngày trước'},
        {value: '28daysAgo', text: '28 ngày trước'},
        {value: '30daysAgo', text: '30 ngày trước'},
        {value: '60daysAgo', text: '60 ngày trước'},
        {value: '90daysAgo', text: '90 ngày trước'},
        {value: '30daysAgo', text: 'Tháng này'},
        {value: 'lastMonth', text: 'Tháng trước'}
      ],
      results: null,
      intervalId: null, // Added to store the interval ID
      lastUpdated: null,

      // date range picker
      localeData: {
        direction: 'ltr',
        format: 'dd/mm/yyyy',
        separator: ' - ',
        applyLabel: 'Áp dụng',
        cancelLabel: 'Hủy',
        weekLabel: 'Tuần',
        customRangeLabel: 'Khoảng',
        daysOfWeek: ['CN', 'Hai', 'Ba', 'Tư', 'Năm', 'Sáu', 'Bảy'],
        monthNames: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5',
          'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
        firstDay: 0
      },
      opens: 'right',
      togglePicker: false,
      dateRange: {
        startDate: today,
        endDate: today,
      },
    };
  },
  created() {
    this.getData();
    this.intervalId = setInterval(this.getData, 300000); // 5 minutes in milliseconds
  },
  beforeDestroy() {
    clearInterval(this.intervalId); // Clear the interval when the component is destroyed
  },
  methods: {

    async getData() {
      try {
        let params = {};
        if ('customize' === this.selectedTimeRange
          && this.dateRange?.startDate
          && this.dateRange?.endDate) {

          const startDate = new Date(this.dateRange.startDate);
          const endDate = new Date(this.dateRange.endDate);
          const today = new Date();

          // Tính số ngày trước từ ngày kết thúc
          const diffStartDays = Math.round((today - startDate) / (1000 * 60 * 60 * 24));
          const diffEndDays = Math.round((today - endDate) / (1000 * 60 * 60 * 24));

          params = {
            startDate: `${diffStartDays}daysAgo`,
            endDate: `${diffEndDays}daysAgo`
          };
        } else {
          params = {
            date: this.selectedTimeRange
          };
        }

        // Convert params to query string
        let qs = Object.keys(params)
          .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
          .join('&');

        const {data} = await this.$axios.get(`${this.$configs.api}/api/cp/analytics/data?${qs}`);
        if (data?.results) {
          this.results = data.results;
          this.lastUpdated = new Date().toLocaleString('vi-VN', {timeZone: 'Asia/Ho_Chi_Minh'}); // Update lastUpdated with the current date and time in Vietnam timezone
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },

    getAnalytics() {
      if ('customize' === this.selectedTimeRange) {
        this.togglePicker = true
        this.getData()
      } else {
        this.togglePicker = false

        let _today = new Date()
        _today.setHours(0, 0, 0, 0)
        this.dateRange.startDate = _today;
        this.dateRange.endDate = _today;
        this.getData()
      }
    },
    dateFormat(classes, date) {
      if (!classes.disabled) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Đặt giờ phút giây của ngày hôm nay về 0 để so sánh chính xác

        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1); // Thêm một ngày để có ngày mai

        const threeHundredDaysAgo = new Date();
        threeHundredDaysAgo.setDate(threeHundredDaysAgo.getDate() - 300);
        threeHundredDaysAgo.setHours(0, 0, 0, 0); // Đặt giờ phút giây của ngày cách đây 300 ngày về 0

        classes.disabled = date.getTime() < threeHundredDaysAgo.getTime() || date.getTime() > tomorrow.getTime();
      }
      return classes;
    },
    pickerUpdate() {
      this.getData()
    }

  },
  filters: {
    formatPercent(val) {
      const percent = parseFloat(val) * 100;
      return percent.toFixed(2);
    }
  }
}
</script>

<style scoped>

</style>
